import { useTranslation } from 'react-i18next';

import { DemoNegotiationState } from '@/modules/demoNegotiation/types/demoNegotiationTypes';
import { Box } from '@/modules/theme/components/Box';
import { Heading } from '@/modules/theme/components/Typography';

import { MetricsWrapperStyled } from '../../SuggestedNegotiations.styled';
import { SuggestedNegotiationMetrics } from '../SuggestedNegotiationMetrics/SuggestedNegotiationMetrics';
import { TotalPotentialMetrics } from '../TotalPotentialMetrics/TotalPotentialMetrics';

import { DemoNegotiationsDnD } from './components/DemoNegotiationsDnD/DemoNegotiationsDnD';
import { useGetDemoNegotiationsMetricsQuery } from './hooks/useGetDemoNegotiationsQuery/useGetDemoNegotiationsMetricsQuery';

type DemoNegotiationsProps = {
  isLoading: boolean;
  isError: boolean;
};

export const DemoNegotiations = ({
  isLoading,
  isError,
}: DemoNegotiationsProps) => {
  const { t } = useTranslation('pages/SuggestedNegotiationsPage');

  const {
    data: demoSuggestedNegotiationsMetrics,
    isFetching: isDemoSuggestedNegotiationsMetricsFetching,
    isError: isDemoSuggestedNegotiationsMetricsError,
  } = useGetDemoNegotiationsMetricsQuery({
    state: [DemoNegotiationState.SUGGESTED],
  });

  const {
    data: demoPotentialNegotiationsMetrics,
    isFetching: isDemoPotentialNegotiationsMetricsFetching,
    isError: isDemoPotentialNegotiationsMetricsError,
  } = useGetDemoNegotiationsMetricsQuery({
    state: [DemoNegotiationState.SUGGESTED, DemoNegotiationState.ESTIMATED],
  });

  return (
    <Box as="main" pl={4} pr={4} mb={2}>
      <Heading variant="h2" ml={3}>
        {t('DigiProc potential')}
      </Heading>
      <MetricsWrapperStyled>
        <SuggestedNegotiationMetrics
          metrics={demoSuggestedNegotiationsMetrics}
          isFetching={isDemoSuggestedNegotiationsMetricsFetching || isLoading}
          isError={isDemoSuggestedNegotiationsMetricsError || isError}
        />
        <TotalPotentialMetrics
          metrics={demoPotentialNegotiationsMetrics}
          isFetching={isDemoPotentialNegotiationsMetricsFetching || isLoading}
          isError={isDemoPotentialNegotiationsMetricsError || isError}
        />
      </MetricsWrapperStyled>
      <DemoNegotiationsDnD />
    </Box>
  );
};
